import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { toLocalTime } from '../../utils/helper';

const Indicator = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  height: 14px;
  width: 14px;
  background-color: red;
  border-radius: 100%;
`;

const statuses = { // not used: 'active'
  successful: 'completed',
  participation: 'upcoming',
};

const mapStateToProps = ({ user: { permissions } }) => ({
  permissions: permissions || [],
});

const Item = ({ permissions, item, onSelect }) => (
  <div
    className={`tile_link ${statuses[item.type]}`}
    onClick={() => {
      if (typeof onSelect === 'function') onSelect(item.storage_id, item.file_link, item.original_name);
    }}
  >
    {!item.viewed && <Indicator />}
    <div className="training_title_block">
      <p className="title tl">{item.titleText}</p>
      <p className="tl">
        {permissions.includes('MY_CERTIFICATES_DOWNLOAD') && <a href={item.file_link}>{item.original_name}</a>}
      </p>
    </div>
    <p className="tl">
      <FormattedMessage id="certificates_completedDate" values={{ date: toLocalTime(item.end_date) }} />
    </p>
    <p className="tl"><FormattedMessage id="certificates_certificateType" values={{ type: item.type }} /></p>
  </div>
);

Item.propTypes = {
  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  onSelect: PropTypes.func,
};

export default connect(mapStateToProps)(Item);



// WEBPACK FOOTER //
// ./src/views/_Certificates/Item.js